import React from "react";
import { Link } from "react-router-dom";
import { LOGO_MARK } from "@/lib/brand";
import ReviewBadges from "@/components/ReviewBadges";

const Footer = () => (
  <footer className="bg-navy text-slate-300" style={{ backgroundColor: "#16305C" }}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="h-10 w-10 rounded-lg bg-white flex items-center justify-center shrink-0 p-1">
              <img src={LOGO_MARK} alt="TradeOff by Blue Shuck" className="h-full w-full object-contain" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-xl font-bold text-white">TradeOff</span>
              <span className="text-[10px] font-medium text-slate-400 tracking-wide mt-0.5">by Blue Shuck</span>
            </span>
          </div>
          <p className="mt-4 text-sm max-w-sm text-slate-400">
            Takeoff, estimating and progress billing built for UK subcontractors. One low-cost workspace, no per-seat games.
          </p>
          <div className="mt-6" data-testid="footer-reviews">
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3">Don't just take our word for it</p>
            <ReviewBadges className="justify-start" />
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Product</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/#features" className="hover:text-white">Features</a></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/register" className="hover:text-white">Get started</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact</Link></li>
            <li><a href="/#workflow" className="hover:text-white">How it works</a></li>
            <li><Link to="/vs/planswift" className="hover:text-white" data-testid="footer-vs-planswift">vs PlanSwift</Link></li>
            <li><Link to="/vs/countfire" className="hover:text-white" data-testid="footer-vs-countfire">vs Countfire</Link></li>
            <li><Link to="/vs/costx" className="hover:text-white" data-testid="footer-vs-costx">vs CostX</Link></li>
            <li><Link to="/vs/kreo" className="hover:text-white" data-testid="footer-vs-kreo">vs Kreo</Link></li>
            <li><a href="https://www.blueshuckconsulting.com/blog" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-blog">Blog</a></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy &amp; Cookies</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/subprocessors" className="hover:text-white" data-testid="footer-subprocessors">Sub-processors</Link></li>
            <li><Link to="/accessibility" className="hover:text-white" data-testid="footer-accessibility">Accessibility</Link></li>
            <li>
              <button
                type="button"
                onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
                className="hover:text-white text-left"
                data-testid="footer-cookie-settings"
              >
                Cookie settings
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 text-xs text-slate-400 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Blue Shuck Consulting Ltd · Registered in England &amp; Wales, Company No. 17308746</span>
        <span>Made in the UK · Prices in GBP</span>
      </div>
    </div>
  </footer>
);

export default Footer;
